export const modalId = 'ConfirmChangeFromRecurrenceBulkToRegularOrderModal'
